module.exports = __webpack_public_path__ + "img/rainbowmakiohnehintergrund.5f4b68d8.png";